export default {
  createNotification,
  sendNotify,
}

const notifyConfig = {
  icon: 'https://i.imgur.com/3vAVHXo.png',
}
function createNotification() {
  if (!('Notification' in window)) {
    // 檢查瀏覽器是否支援通知
    console.log('This browser does not support notification')
  } else if (Notification.permission === 'granted') {
    // 使用者已同意通知
    var notification = new Notification('目前已訂閱', notifyConfig)
  } else if (Notification.permission !== 'denied') {
    // 通知權限為 default (未要求) or undefined (老舊瀏覽器的未知狀態)，向使用者要求權限
    Notification.requestPermission(function (permission) {
      if (permission === 'granted') {
        var notification = new Notification('Hi there!', notifyConfig)
      }
    })
  }
}

function sendNotify(msg) {
  let options = {
    body: msg.body,
    requireInteraction: true,
  }
  let notify = new Notification(msg.title, options)
  notify.onclick = function (e) {
    // Case 3: 綁定 click 事件
    e.preventDefault()
    setTimeout(notify.close(), 5000)
  }
  notify.onerror = function (e) {
    console.log('====>erro', e)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/tool/notificaiton.js